import type { ProfileGalleryVideo, ServiceDoc } from '@makhe/shared';

export interface ReelClip {
  id: string;
  url: string;
  poster?: string;
  source: 'gallery' | 'service';
}

/** Gallery first, then unique listing videos so an empty reel still shows work. */
export function sellerReel(
  gallery: ProfileGalleryVideo[] | undefined,
  services: Pick<ServiceDoc, 'id' | 'media'>[],
): ReelClip[] {
  const clips: ReelClip[] = [];
  const seen = new Set<string>();

  for (const clip of gallery ?? []) {
    if (!clip.url || seen.has(clip.url)) continue;
    seen.add(clip.url);
    clips.push({
      id: clip.id,
      url: clip.url,
      poster: clip.thumbnailURL,
      source: 'gallery',
    });
  }

  for (const service of services) {
    const url = service.media.videoURL;
    if (!url || seen.has(url)) continue;
    seen.add(url);
    clips.push({
      id: `service-${service.id}`,
      url,
      poster: service.media.videoThumbnailURL,
      source: 'service',
    });
  }

  return clips;
}
